import React from 'react'

const Footer = () => {
    return <footer className='bg-violet-700 text-white text-center py-8 '>
        <div className="container mx-auto font-bold relative inset-x-0 bottom-0 ">
        copyright &copy; 2022. All Rights Reserved 
        </div>
    </footer>
}
export default Footer
